import {
  Sparkles, DoorOpen, LogOut, Wifi, Home, ScrollText, Car, Trash2,
  UtensilsCrossed, TramFront, Siren, MessageCircle, Waves, Flower2,
  Sun, Beef, Dog, Coffee, Dumbbell, Tv, Luggage, Clock, Plane, Star,
  Wine, ShoppingBag, MapPin, Camera, Key, Info,
  Snowflake, Flame, Baby, Bike, Bus, Bath, WashingMachine,
} from "lucide-react";

// Icon registry — host can pick any of these per section
export const ICONS = {
  sparkles: Sparkles, door: DoorOpen, logout: LogOut, wifi: Wifi, home: Home,
  rules: ScrollText, car: Car, trash: Trash2, utensils: UtensilsCrossed,
  tram: TramFront, siren: Siren, chat: MessageCircle, pool: Waves, spa: Flower2,
  terrace: Sun, bbq: Beef, pet: Dog, coffee: Coffee, gym: Dumbbell, tv: Tv,
  luggage: Luggage, clock: Clock, plane: Plane, star: Star, wine: Wine,
  shopping: ShoppingBag, map: MapPin, camera: Camera, key: Key, info: Info,
  snow: Snowflake, flame: Flame, baby: Baby, bike: Bike, bus: Bus, bath: Bath,
  washer: WashingMachine,
};
export const ICON_KEYS = Object.keys(ICONS);
export const Icon = ({ name, ...p }) => {
  const C = ICONS[name] || Info;
  return <C {...p} />;
};

let _c = 0;
export const uid = () => `${Date.now().toString(36)}${(_c++).toString(36)}${Math.random().toString(36).slice(2, 6)}`;

export const BLOCK_TYPES = [
  { type: "heading", label: "Titolo", icon: "sparkles" },
  { type: "text", label: "Testo", icon: "chat" },
  { type: "image", label: "Immagine", icon: "camera" },
  { type: "info", label: "Info", icon: "info" },
  { type: "wifi", label: "Wi-Fi", icon: "wifi" },
  { type: "hours", label: "Orario", icon: "clock" },
  { type: "list", label: "Lista", icon: "rules" },
  { type: "steps", label: "Manuale visuale", icon: "info" },
  { type: "phone", label: "Telefono", icon: "chat" },
  { type: "address", label: "Indirizzo / Mappa", icon: "map" },
  { type: "button", label: "Pulsante / CTA", icon: "star" },
];

export const newBlock = (type) => {
  const base = { id: uid(), type };
  const c = {
    heading: { text: "Titolo" },
    text: { text: "" },
    image: { url: "", caption: "" },
    info: { label: "", value: "" },
    wifi: { network: "", password: "" },
    hours: { label: "Orario", value: "" },
    list: { items: [""] },
    steps: { title: "", steps: [{ text: "", image: "" }] },
    phone: { label: "Telefono", value: "" },
    address: { value: "" },
    button: { label: "Apri sulla mappa", action: "map", value: "" },
  }[type] || {};
  return { ...base, content: c };
};

export const CTA_ACTIONS = [
  { value: "map", label: "Apri sulla mappa" },
  { value: "link", label: "Apri link" },
  { value: "call", label: "Chiama" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Invia email" },
  { value: "copy", label: "Copia testo" },
];

// Ready-made custom section templates
export const CUSTOM_TEMPLATES = [
  { key: "custom", title: "Piscina", subtitle: "Orari e regole", icon: "pool" },
  { key: "custom", title: "Spa", subtitle: "Relax e benessere", icon: "spa" },
  { key: "custom", title: "Terrazza", subtitle: "Il nostro spazio all'aperto", icon: "terrace" },
  { key: "custom", title: "Barbecue", subtitle: "Come usarlo", icon: "bbq" },
  { key: "custom", title: "Animali", subtitle: "Pet policy", icon: "pet" },
  { key: "custom", title: "Colazione", subtitle: "Cosa trovi", icon: "coffee" },
  { key: "custom", title: "Palestra", subtitle: "Accesso e orari", icon: "gym" },
  { key: "custom", title: "Smart TV", subtitle: "Come funziona", icon: "tv" },
  { key: "custom", title: "Deposito bagagli", subtitle: "Prima e dopo", icon: "luggage" },
  { key: "custom", title: "Late check-out", subtitle: "Su richiesta", icon: "clock" },
  { key: "custom", title: "Transfer aeroporto", subtitle: "Come organizzarlo", icon: "plane" },
];

export const newSection = (tpl) => ({
  id: uid(), key: tpl.key || "custom", title: tpl.title || "Nuova sezione",
  subtitle: tpl.subtitle || "", icon: tpl.icon || "info", cover: null,
  position: 0, is_visible: true, type: "custom", blocks: [],
});

export const sectionVisible = (s) => (s.is_visible ?? s.enabled ?? true);
export const sortSections = (secs) => (secs || []).slice().sort((a, b) => (a.position ?? a.order ?? 0) - (b.position ?? b.order ?? 0));
